import variables from './variables.esm.js';
import reset from './reset.esm.js';
import layout from './layout.esm.js';
import typeset from './typeset.esm.js';
import animations from './animations.esm.js';
import extensions from './extensions.esm.js';
import palette from './palette.esm.js';

const rules = [
  variables,
  reset,
  layout,
  typeset,
  animations,
  extensions,
  palette
];

export { rules };
//# sourceMappingURL=rules.esm.js.map
